import React from "react"
import styled from "styled-components"
import branding from "../../branding/branding"
import BottomBar from "./bottomBar/BottomBar"
import ContentPage from "./ContentPage"
import TopBar from "./topBar/TopBar"

const Wrapper = styled.main`
    overflow-x: hidden;
    overflow-y: auto;
    height: 100vh !important;

    button,
    button:focus,
    button:active:focus,
    button.inverse:not(:disabled):not(.disabled):active:focus {
        color: ${branding.configuration.maincolor || "#6DD400"};
        background-color: #fff;
        border: 1px solid ${branding.configuration.maincolor || "#6DD400"};
        border-radius: 5px;
    }
    button:focus,
    button:not(:disabled):not(.disabled):active:focus {
        box-shadow: none;
    }
    button:not(:disabled):not(.disabled):active:focus {
        color: #fff;
        background-color: ${branding.configuration.maincolor || "#6DD400"};
        border: 1px solid ${branding.configuration.maincolor || "#6DD400"};
    }
    button:hover {
        color: ${branding.configuration.maincolor || "#6DD400"};
        background-color: #fff;
        border: 1px solid ${branding.configuration.maincolor || "#6DD400"};
    }
    button.inverse {
        color: #fff;
        background-color: ${branding.configuration.maincolor || "#6DD400"};
        border: 1px solid ${branding.configuration.maincolor || "#6DD400"};
    }
    button.inverse:hover {
        color: #fff;
        background-color: ${branding.configuration.maincolor || "#6DD400"};
        border: 1px solid ${branding.configuration.maincolor || "#6DD400"};
    }

    button.btn-link {
        border: none;
    }

    .form-group {
        margin-bottom: 20px;
    }

    .form-group.invalid-group {
        margin-bottom: 0;
        margin-top: calc(-20px + 0.25rem);
    }

    .form-group .form-label {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #202428;
        margin-bottom: 10px;
    }

    .form-group .valid-feedback {
        font-size: 10px;
        line-height: 12px;
        color: #727272;
    }

    .form-group .invalid-feedback {
        font-size: 10px;
        line-height: 12px;
        color: #ff0000;
    }

    .form-control {
        border-radius: 5px;
        box-shadow: initial;
        padding: 7px 14.51px;
        background-image: initial;
        background-position: initial;
        background-size: initial;
        font-size: 14px;
        line-height: 16px;
    }
    .form-control:focus {
        box-shadow: initial;
    }

    .form-control.is-valid {
        border: 1px solid #d9d9d9;
    }

    .form-control.is-invalid {
        background: rgba(255, 0, 0, 0.1);
        border: 1px solid #ff0000;
    }

    .form-control[readonly] {
        background: #e5e5e5;
        border: 1px solid #727272;
        opacity: 1;
    }

    .form-check-inline {
        & > .form-check:first-child {
            padding-left: 0;
        }
    }
`

const MainContent: React.FC<{}> = () => {
    return (
        <Wrapper>
            <TopBar />
            <ContentPage />
            <BottomBar />
        </Wrapper>
    )
}

export default MainContent
